import {Box, Typography, useTheme, Stack, Chip, Divider} from "@mui/material";
import {scopeToString} from "../../utils/formatData";

const ScopeInfo = ({scope}) => {
  const theme = useTheme();

  if (!scope) {
    return <Typography>Cargando...</Typography>;
  }

  return (
    <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
      <Box>
        <Typography variant="h5" gutterBottom sx={{fontWeight: "bold", color: theme.palette.text.primary}}>
          {scopeToString(scope)}
        </Typography>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          {scope?.description || "Sin descripción"}
        </Typography>
      </Box>

      <Divider />

      <Stack direction="column" spacing={1}>
        <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
          <Typography variant="subtitle2" sx={{fontWeight: "bold", minWidth: "100px"}}>
            Recurso:
          </Typography>
          <Chip label={scope.resource} size="small" variant="outlined" />
        </Box>

        {scope.subresource && (
          <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
            <Typography variant="subtitle2" sx={{fontWeight: "bold", minWidth: "100px"}}>
              Subrecurso:
            </Typography>
            <Chip label={scope.subresource} size="small" variant="outlined" />
          </Box>
        )}

        <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
          <Typography variant="subtitle2" sx={{fontWeight: "bold", minWidth: "100px"}}>
            Acción:
          </Typography>
          <Chip label={scope.action} size="small" variant="outlined" color="primary" />
        </Box>

        <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
          <Typography variant="subtitle2" sx={{fontWeight: "bold", minWidth: "100px"}}>
            Alcance:
          </Typography>
          <Chip
            label={scope.ownership === "global" ? "Global" : scope.ownership === "tenant" ? "Tenant" : "Self"}
            size="small"
            variant="outlined"
            color={scope.ownership === "global" ? "error" : scope.ownership === "tenant" ? "warning" : "success"}
          />
        </Box>

        {scope.product_id && (
          <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
            <Typography variant="subtitle2" sx={{fontWeight: "bold", minWidth: "100px"}}>
              Producto:
            </Typography>
            <Chip label={scope.product_id} size="small" variant="filled" />
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default ScopeInfo;
